import { render, staticRenderFns } from "./BaseFilter.vue?vue&type=template&id=da84f640&scoped=true"
import script from "./BaseFilter.vue?vue&type=script&lang=js"
export * from "./BaseFilter.vue?vue&type=script&lang=js"
import style0 from "./BaseFilter.vue?vue&type=style&index=0&id=da84f640&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da84f640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da84f640')) {
      api.createRecord('da84f640', component.options)
    } else {
      api.reload('da84f640', component.options)
    }
    module.hot.accept("./BaseFilter.vue?vue&type=template&id=da84f640&scoped=true", function () {
      api.rerender('da84f640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/filter/BaseFilter.vue"
export default component.exports